















import moment from 'moment'

import { Component, Vue, Prop } from 'vue-property-decorator'
import { ArticleBase, ArticleTranslating } from '@/types/articles.type'

const URL_PREFIX = 'https://github.com/LCTT/TranslateProject'

@Component
class LcArticleListItem extends Vue {
  @Prop(String) type!: string
  @Prop(Number) id!: number
  @Prop(Object) article!: ArticleBase

  get asTranslating () {
    return this.article as ArticleTranslating
  }

  get days () {
    return moment().diff(this.article.time, 'days')
  }

  get date () {
    switch (this.type) {
      case 'new':
        return this.article.time.format('MM - DD')
      case 'mostWanted':
        return this.article.time.format('YYYY/MM/DD')
    }
  }

  get filename () {
    const basename = this.article.path.split('/').pop()
    return basename && basename!.replace(/^\d{8} |\.md$/g, '')
  }

  get author () {
    return this.asTranslating.author
  }

  get viewUrl () {
    return `${URL_PREFIX}/blob/master/${this.article.path}`
  }

  get editUrl () {
    return `${URL_PREFIX}/edit/master/${this.article.path}`
  }
}
export default LcArticleListItem
